import React, {useState, useEffect} from 'react';
import {Space, Tag, Image, Avatar, Button} from 'antd'
import {EditOutlined} from "@ant-design/icons"
import {VersionSON, SubjectSON, GradeSON, SectionJSON} from '../../util/dict'
import {split} from '../../util/transfer'

export default function BaseInfo({data={}, lecturerList=[], onEdit}) {
    const [labels, setLabels] = useState([])
    useEffect(() => {
        let labels = []
        if (data.sectionCode) {
            labels.push(SectionJSON[data.sectionCode])
        }
        if (data.gradeCode) {
            labels.push(GradeSON[data.gradeCode])
        }
        if (data.subjectCode) {
            labels.push(SubjectSON[data.subjectCode])
        }
        if (data.versionCode) {
            labels.push(VersionSON[data.versionCode])
        }
        setLabels(labels.concat(split(data.label,'|')))
    }, [data.courseId])


    return <div className="flexbox white-bg pdv40 pdh32 relative" style={{minWidth: 800, maxWidth: 1200}}>
        <Image
            preview={false}
            className="border-radius"
            width={300}
            height={160}
            src={data.coverImg}
        />
        <div className="mgl28 flex1">
            <div className="gray-dark fts-18 bold mgb12">{data.courseName}</div>
            <div className="mgb12">
                <Space>
                    {labels.map((item, i) => item ? <Tag key={item + '_' + i}>{item}</Tag> : null)}
                </Space>
            </div>
            <div style={{overflowX: "auto"}}>
                <Space className="mgv12">
                    {lecturerList && lecturerList .map((lecturer) => <div key={lecturer.lecturerId}
                                                         className="flexbox border-radius border pdv12 pdh12"
                                                         style={{width: 214, height: 74}}>
                        <Avatar
                            style={{borderRadius: 22, width: 44, height: 44}}
                            src={lecturer.headImg}/>
                        <div className="flex1 mgl12">
                            <div className="bold gray-dark fts-14">{lecturer.lecturerName}</div>
                            <div className="gray ellipsis mgt6 fts-13">{lecturer.title}</ div>
                        </div>
                    </div>)}
                </Space>
            </div>
        </div>

        <Button
            onClick={onEdit}
            style={{position: "absolute", right: 16, top: 16}}
            type="text"
            icon={<EditOutlined/>}
        >编辑</Button>
    </div>
}




